<template>

  <div>
    <!-- 银联支付 -->
    <div class="pay-box" v-if="result.status === 3">
      <p class="amount-payable-row">
        应付金额：<span class="amount-payable-price">¥<span>9998</span></span>
      </p>
      <img src="../assets/pay-6.png" class="pay-icon">
      <span class="pay-msg">点击跳转第三方支付页面</span>
      <button type="button" class="pay-btn">暂未完成支付</button>
    </div>


    <!-- 审核成功显示 -->
    <div class="result-box" v-if="result.status === 4">
      <img src="../assets/icon-success.png">支付成功
    </div>

    <!-- 审核成功-支付失败显示 -->
    <!-- <div class="result-box" v-if="result.status === =3">
      <img src="../assets/icon-fail.png">未检测到付款
    </div> -->

    <!-- 审核失败显示 -->
    <div class="result-box" v-if="result.status === 2">
      <img src="../assets/icon-fail.png">
      <span>审核失败</span>
      <span class="fail-msg">{{ result.reason }}</span>
    </div>

    <!-- 正在审核显示 -->
    <div class="result-box" v-if="result.status === 1">
      <img src="../assets/icon.png">
      <span>正在审核中，请稍后</span>
    </div>


    <!-- 审核成功显示 -->
    <div class="center-btn-box" v-if="result.status === 3">
      <div class="btn-box" style="justify-content: center;">
        <button type="button"   @click="$router.push('/index')">返回首页</button>
      </div>
    </div>

    <!-- 审核成功-支付失败显示 -->
    <div class="center-btn-box" v-if="result.status === -1">
      <div class="btn-box" style="justify-content: center;">
        <button type="button" class="border-btn"  @click="$router.push('/entry-enterprise-authorization-regulations')">上一步</button>
        <button type="button">重新支付</button>
      </div>
    </div>

    <!-- 审核失败显示 和正在审核显示 -->
    <div class="center-btn-box" v-if="true || result.status === 1 || result.status === 2">
      <div class="btn-box" style="justify-content: center;">
        <button type="button" @click="reset()">重新提交认证信息</button>
      </div>
    </div>
  </div>

</template>

<script>

export default {
  name: 'entry-verification-number-step-4',
  props: {
    result: {
      default: {},
    },
  },
  data() {
    return {};
  },
  mounted() {
  },
  methods: {
    prev() {
      this.$emit('prev', '');
    },
    next() {
      this.$emit('next', '');
    },
    reset() {
      this.$emit('reset', '');
    },
  },
}
</script>

<style scoped>

.form-row {
  width: 352px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
}

.form-label {
  width: 83px;
  font-weight: bold;
  font-size: 16px;
  color: #333333;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-right: 5px;
  box-sizing: border-box;
}

.form-input-box {
  flex: 1;

}

.form {
  width: 707px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
}

>>>.el-input__inner {
  border-radius: 8px !important;
  border: 1px solid #666666 !important;
  color: #606266 !important;
  height: 30px !important;
  line-height: 30px !important;
}

>>>.el-input__inner::placeholder {
  color: #999999 !important;
}
.get-code-btn {
  color: #FFFFFF;
  font-size: 16px;
  width: 112px;
  height: 30px;
  line-height: 30px;
  background-color: #FF6619;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
}
.btn-box {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.btn-box>button {
  width: 152px;
  height: 36px;
  line-height: 36px;
  background-color: #FF6619;
  border-radius: 8px;
  color: #FFFFFF;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
  box-sizing: border-box;
}

.btn-box>button:last-child {
  margin-right: 0;
}

.btn-box>button.border-btn {
  border: 1px solid #666666;
  color: #666666;
  background-color: #EEEEEE;
}
.btn-box {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 75px 0 33px;
}

.btn-box>button {
  width: 152px;
  height: 36px;
  line-height: 36px;
  background-color: #FF6619;
  border-radius: 8px;
  color: #FFFFFF;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 14px;
  box-sizing: border-box;
}

.btn-box>button:last-child {
  margin-right: 0;
}

.btn-box>button.border-btn {
  border: 1px solid #666666;
  color: #666666;
  background-color: #EEEEEE;
}

.top-title {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background: linear-gradient(180deg, #F3DC99, #F0AE46);
  font-size: 24px;
  font-weight: bold;
  color: #FFFFFF;
  display: flex;
  justify-content: center;
  align-items: center;
}

.process-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-bottom: 34px;
}

.process {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.process::after {
  content: "";
  position: absolute;
  left: calc(50% + 18px);
  bottom: 18px;
  width: calc(100% - 36px);
  height: 2px;
  background-color: #FF6619;
}

.process:last-child::after {
  background-color: initial;
}

.process-label {
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
}

.circle {
  width: 36px;
  height: 36px;
  line-height: 36px;
  border: 2px solid #999999;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #999999;
  box-sizing: border-box;
}

.circle.border {
  border: 2px solid #FF6619;
  color: #F37C3D;
}

.circle.bg {
  background-color: #FF6619;
  color: #FFFFFF;
  border: none;
}

.process.active .process-label {
  color: #FF6619;
}

.fail-msg {
  text-align: center;
  font-size: 16px;
  color: #666666;
  margin-top: 15px;
}

.pay-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 0;
}

.amount-payable-row {
  color: #333333;
  font-size: 16px;
  margin-bottom: 35px;
}

.amount-payable-price {
  color: #D43634;
  font-size: 16px;
}

.amount-payable-price>span {
  font-size: 26px;
  font-weight: bold;
}

.pay-icon {
  width: 196px;
  margin-bottom: 6px;
}

.pay-msg {
  color: #333333;
  font-size: 12px;
}

.pay-btn {
  color: #666666;
  font-size: 16px;
  width: 152px;
  height: 36px;
  line-height: 36px;
  background-color: #EEEEEE;
  border: 1px solid #666666;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 70px;
}

.result-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  padding: 70px 0 20px;
}

.result-box>img {
  width: 72px;
  margin-bottom: 12px;
}
</style>
